import { html, property } from 'lit-element';
import { KatLitElement, register } from '../../shared/base';
import baseStyles from '../../shared/base/base.lit.scss';
import styles from './activity-list-item.lit.scss';

/**
 * @component {kat-activity-list-item} KatActivityListItem An activity card intended to be slotted into an Activity List.
 * @status Production
 * @a11y {keyboard}
 * @a11y {sr}
 * @a11y {contrast}
 */
@register('kat-activity-list-item')
export class KatActivityListItem extends KatLitElement {
  static get styles() {
    return [baseStyles, styles];
  }

  /**
   * The header content of the list-item.
   */
  @property()
  header: string;

  /**
   * A string for displaying the timestamp of the card such as "Last updated: HH:MM:SS" or "Last updated 3 seconds ago"
   */
  @property()
  timestamp: string;

  /**
   * Specifies the type of activity-list-item to be displayed. Defaults to "default".
   * @enum {value} default This is the default activity-list-item variant.
   * @enum {value} warning Signals moderate issues that may not require immediate attention.
   * @enum {value} danger Signals critical issues that likely require immediate attention.
   */
  @property()
  variant?: 'default' | 'warning' | 'danger' = 'default';

  render() {
    return html`
      <div class="card">
        <div class="card-header">
          <span>${this.header}</span>
          <slot name="secondary-actions"></slot>
        </div>
        <slot></slot>
        <span class="card-date">${this.timestamp}</span>
        <slot name="primary-action"></slot>
      </div>
    `;
  }
}
